// src/pages/SSOLoginPage.tsx
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { useFirebase } from "../hooks/useFirebase";
import * as service from '../services/api';
import Layout from "../components/layout/Layout";
const SSOLoginPage: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const firebaseApp = useFirebase();
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const uid = params.get("fuid");

        if (!uid || !firebaseApp) {
            console.warn("UID or Firebase app");
            navigate("/login");
            return;
        }

        const auth = getAuth(firebaseApp);
        const login = async () => {
            try {
                if (!uid) return null;
                const response = await fetch(service.API_ENDPOINTS.getCustomToken, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ uid }),
                });
                const data = await response.json();
                if (data.success && data.customToken) {
                    await signInWithCustomToken(auth, data.customToken);
                    console.log("Token generated successfully");

                    navigate("/account");
                } else {
                    console.error("Token generation failed", data);
                    navigate("/login");
                }
            } catch (err) {
                console.error("Login failed", err);
                navigate("/login");
            } finally {
                setLoading(false);
            }
        };
        login();
    }, [firebaseApp, location, navigate]);

    return (
        <Layout showNavOptions={true} showCurrentUserDetails={true} header={true} footer={false} >
            <div style={{ padding: "2rem", textAlign: "center" }}>
                <p>Redirecting ...</p>
            </div>
        </Layout>
    );
};
export default SSOLoginPage;
